

export function initializeStackCards(containerId, cardClass) {
  const container = document.getElementById(containerId);

  if (!container) {
      console.warn(`${containerId} element not found`);
      return;
  }

  const cards = Array.from(container.getElementsByClassName(cardClass));

  function setInitialOrder() {
      cards.forEach((card, index) => {
          card.classList.add(`order-${index + 1}`);
      });
      cards[0].classList.add('active');
  }

  function updateOrderForActiveCard() {
      const activeIndex = cards.findIndex(card => card.classList.contains('order-1'));

      setTimeout(() => {
          cards.forEach(card => {
              card.className = card.className.replace(/\border-\d+\b/, '');
          });

          cards[activeIndex].classList.add(`order-${cards.length}`);

          let order = 1;
          for (let i = activeIndex + 1; i < cards.length; i++) {
              cards[i].classList.add(`order-${order}`);
              order++;
          }
          for (let i = 0; i < activeIndex; i++) {
              cards[i].classList.add(`order-${order}`);
              order++;
          }

          cards[activeIndex].classList.remove('active');
          cards[(activeIndex + 1) % cards.length].classList.add('active');
      }, 0);
  }

  function updateOrderForNonActiveCard(clickedIndex) {
      const activeIndex = cards.findIndex(card => card.classList.contains('order-1'));

      setTimeout(() => {
          cards.forEach(card => {
              card.className = card.className.replace(/\border-\d+\b/, '');
          });

          cards[clickedIndex].classList.add('order-1');

          let order = 2;
          for (let i = clickedIndex + 1; i < cards.length; i++) {
              if (i !== activeIndex) {
                  cards[i].classList.add(`order-${order}`);
                  order++;
              }
          }
          for (let i = 0; i < clickedIndex; i++) {
              if (i !== activeIndex) {
                  cards[i].classList.add(`order-${order}`);
                  order++;
              }
          }

          cards[activeIndex].classList.add(`order-${cards.length}`);
          cards[activeIndex].classList.remove('active');
          cards[clickedIndex].classList.add('active');
      }, 0);
  }

    function onCardClick(event) {
        // Check if the click event target is a link

        if (!event.target.closest('a')) {
            const clickedCard = event.currentTarget;
            const clickedIndex = cards.indexOf(clickedCard);

            cards.forEach(card => card.classList.remove('active'));

            if (cards[clickedIndex].classList.contains('order-1')) {
                updateOrderForActiveCard();
            } else {
                updateOrderForNonActiveCard(clickedIndex);
            }
        }
    }

  cards.forEach(card => {
      card.addEventListener('click', onCardClick);
  });

  setInitialOrder();
}



export function initializeFeaturedCards() {
  const featuredStack = document.getElementById('featuredCards');

  if (!featuredStack) {
    //   console.warn('Featured stack element not found');
      return;
  }

  const cards = Array.from(featuredStack.getElementsByClassName('featured_card'));

  function setInitialOrder() {
      cards.forEach((card, index) => {
          card.classList.add(`order-${index + 1}`);
      });
      cards[0].classList.add('active');
  }

  function updateOrderForActiveCard() {
      const activeIndex = cards.findIndex(card => card.classList.contains('order-1'));

      setTimeout(() => {
          cards.forEach(card => {
              card.className = card.className.replace(/\border-\d+\b/, '');
          });

          cards[activeIndex].classList.add(`order-${cards.length}`);

          let order = 1;
          for (let i = activeIndex + 1; i < cards.length; i++) {
              cards[i].classList.add(`order-${order}`);
              order++;
          }
          for (let i = 0; i < activeIndex; i++) {
              cards[i].classList.add(`order-${order}`);
              order++;
          }

          cards[activeIndex].classList.remove('active');
          cards[(activeIndex + 1) % cards.length].classList.add('active');
      }, 0);
  }

  function updateOrderForNonActiveCard(clickedIndex) {
      const activeIndex = cards.findIndex(card => card.classList.contains('order-1'));

      setTimeout(() => {
          cards.forEach(card => {
              card.className = card.className.replace(/\border-\d+\b/, '');
          });

          cards[clickedIndex].classList.add('order-1');

          let order = 2;
          for (let i = clickedIndex + 1; i < cards.length; i++) {
              if (i !== activeIndex) {
                  cards[i].classList.add(`order-${order}`);
                  order++;
              }
          }
          for (let i = 0; i < clickedIndex; i++) {
              if (i !== activeIndex) {
                  cards[i].classList.add(`order-${order}`);
                  order++;
              }
          }

          cards[activeIndex].classList.add(`order-${cards.length}`);

          cards[activeIndex].classList.remove('active');
          cards[clickedIndex].classList.add('active');
      }, 0);
  }

  function onCardClick(event) {

    if (!event.target.closest('a')) {

      const clickedCard = event.currentTarget;
      const clickedIndex = cards.indexOf(clickedCard);

      cards.forEach(card => card.classList.remove('active'));

      if (cards[clickedIndex].classList.contains('order-1')) {
          updateOrderForActiveCard();
      } else {
          updateOrderForNonActiveCard(clickedIndex);
      }
    }
  }

  cards.forEach(card => {
      card.addEventListener('click', onCardClick);
  });

  setInitialOrder();

  // Pagination buttons
  const nextButton = document.querySelector('.featured_buttons.next');
  const prevButton = document.querySelector('.featured_buttons.prev');

  function goToNextCard() {
      const activeCard = document.querySelector('.featured_card.active');
      const activeIndex = cards.indexOf(activeCard);
      const nextIndex = (activeIndex + 1) % cards.length;
      updateOrderForNonActiveCard(nextIndex);
  }

  function goToPrevCard() {
      const activeCard = document.querySelector('.featured_card.active');
      const activeIndex = cards.indexOf(activeCard);
      const prevIndex = (activeIndex - 1 + cards.length) % cards.length;
      updateOrderForNonActiveCard(prevIndex);
  }

  nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      goToNextCard();
  });

  prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      goToPrevCard();
  });
}



// Calculate stack card heights

// featuredCards.js

// Function to calculate and set the height of .featured_stack
function calculateStackHeight() {
    const featuredCard = document.querySelector('.featured_card');
    const featuredStack = document.querySelector('.featured_stack');

    if (featuredCard && featuredStack) {
        const cardHeight = featuredCard.offsetHeight;
        // console.log('calcstackHeight');
        // console.log(cardHeight);
        featuredStack.style.height = `${cardHeight}px`;
    }
}

// Throttling function to limit the frequency of the resize event
function stackThrottle(func, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return func(...args);
    };
}

// Export the functions to be used in the main JS file
export { calculateStackHeight, stackThrottle };
